import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Alert
} from 'reactstrap';

import {
    login,
    loginResponse,
    loginTokenResponse
} from '../actions/login';

import {
    login as loginService,
    tokenLogin as tokenLoginService
} from '../services/login';

import {
    isEmail,
    canLogin
} from "../Helpers";

import env from '../env';
import Spinner from '../components/spinner/Spinner';

const logo = require('../assets/elint-logo-sml.png');


class Login extends React.Component {

    constructor(){
        super();
        this.state = {
            email: '',
            password: '',
            errors: [],
            loggingIn: false,
            loggedIn: false
        };
    }

    componentWillReceiveProps(nextProps){
        const {
            loggingIn,
            loggedIn,
        } = nextProps.account;

        this.setState({loggingIn, loggedIn});

        if(loggedIn)
            this.props.history.push(`${env.url}/`)
    }

    componentDidMount(){

        const {loggedIn} = this.state;

        if(canLogin()){
            if(loggedIn){
                this.props.history.push(`${env.url}/`)
            }else{

                const props = this.props;

                tokenLoginService().then(function(resp){
                    props.loginTokenResponse(resp);
                });

            }
        }
    }

    /**
     * Submit login form
     *
     * @param e
     */
    submitForm = async (e) => {
        e.preventDefault();

        const {email, password} = this.state;
        let errors  = [];

        if(email === '' || password === '' )
            errors.push('Both E-mail & password are required');

        if(!isEmail(email))
            errors.push('A valid E-mail is required!');

        this.setState({errors});

        if(!errors.length){
            this.props.login();

            let formData = new FormData();
            formData.append('email', email);
            formData.append('password', password);

            const resp = await loginService(formData);

            if(!resp.status){
                errors.push(resp.error? resp.error: 'Unable to log in at the moment!');
                this.setState({errors});
                this.props.loginResponse(resp);
            }else {
                this.props.loginResponse(resp);
            }


        }
    };

    /**
     * Register input text change
     *
     * @param evt
     */
    registerInputChange = (evt) => {
        this.setState({
            [evt.target.name] : evt.target.value,
            errors: []
        });
    };

    render() {

        const {errors, loggingIn} = this.state;

        return (
            <div>
                {
                    loggingIn?
                        <Spinner
                            message="Logging in..."
                            overlay={true}/>:null
                }
                <div className="login-screen">
                    <div className="inner">

                        <img src={logo} alt="Elint Logo"/>

                        {
                            errors.map((error, key) => (
                                <Alert key={key} color="danger">
                                    {error}
                                </Alert>
                            ))
                        }

                        <Form>
                            <FormGroup>
                                <Label for="email">Email</Label>
                                <Input
                                    onChange = {this.registerInputChange}
                                    type="email"
                                    name="email"
                                    id="email"
                                    autoComplete="off"
                                    placeholder="jane@example.com" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="password">Password</Label>
                                <Input
                                    onChange = {this.registerInputChange}
                                    type="password"
                                    name="password"
                                    autoComplete="off"
                                    id="password"
                                    placeholder="********" />
                            </FormGroup>

                            <Button
                                onClick={this.submitForm}
                                size="lg"
                                color="primary">
                                Login
                            </Button>
                        </Form>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = ({ account }) => ({
    account: account,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    login: () => login(),
    loginResponse: (resp) => loginResponse(resp),
    loginTokenResponse: (resp) => loginTokenResponse(resp),
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login)



// WEBPACK FOOTER //
// ./src/screens/Login.js